import { Navigate, useParams } from 'react-router-dom';

import { useGetAsignaciones } from '@/shared/actions/erp/activos';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveAsignaciones } from '../../shared/saveAsignaciones';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateAsignacionesPageInterface {}

const UpdateAsignacionesPage: React.FC<UpdateAsignacionesPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_asignacionactivo);

  const { id } = useParams();
  const { data, isLoading } = useGetAsignaciones(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_asignacion_activo) return <Navigate to="/activos/asignaciones" />;

  return <SaveAsignaciones titlePage="Editar Asignaciones" editAsignaciones={data.data} />;
};

export default UpdateAsignacionesPage;
